<template>
  <div v-if="!loading">
    <NoticeBar
      v-if="$store.getters.getIsPreview && $store.getters.getIsPreview === 1"
      background="#FFF6EF"
      color="#FA964E"
      text="提示：当前为预览页面，答案不被记录"
    />
    <div class="cover">
      <!-- 填报记录按钮 -->
      <!-- <div
       v-if="$store.getters.getOrgId != 21 && $store.getters.getToken && $store.getters.getQuesInfo.type === 1"
       @click="handleJump2Record"
       class="record-btn"
      >
       填报记录
      </div> -->
      <!-- 更多按钮 -->
      <MoreBtn
        v-if="moreBtnsShow"
        @showTips="tipsPopup = true"
        @showLeaderBoard="showLeaderBoard = true"
      />
      <!-- 标题 -->
      <h1 v-html="showTitle" v-if="quesInfo?.titleStatus" class="title"></h1>
      <!-- 描述 -->
      <div
        v-html="quesInfo?.content"
        class="tips"
        :class="{ 'ques-tips': quesInfo?.type === 1 }"
      ></div>
      <!-- 说明弹窗 -->
      <TipsPopup
        v-if="tipsPopup"
        :content="quesInfo?.content"
        @close="tipsPopup = false"
      >
      </TipsPopup>
      <!-- 答题榜 -->
      <ActionSheet v-model:show="showLeaderBoard">
        <LeaderBoard />
      </ActionSheet>
      <div class="modules" @click.capture="clickCapture">
        <template v-if="quesInfo?.type === 1">
          <!-- 开始报名 -->
          <!-- 单独修改这套卷按钮大小 -->
          <div
            @click="
              () => {
                handleJump2('list')
              }
            "
            class="modules-item blue ques-type"
            :class="{
              'btn-size':
                questionActiveKey === '119b6b19bd9348b9ad986705598fcc4c',
              'diy-btn-2023412':
                $route.query.questionActiveKey === QUES_KEY_2023_4_12,
              'diy-btn-20240117':
                $route.query.questionActiveKey ===
                '3b42e4f940314db3b110673cf87117ae',
            }"
          >
            <div class="modules-item-icon icon-study"></div>
            <span id="quesBtn" class="modules-item-text">{{
              $store.getters.getBtnText?.quesBtn
            }}</span>
          </div>
          <!-- 个人信息 -->
          <div
            v-if="$store.getters.getBtnText?.personalBtn"
            @click="handleJump2('info')"
            class="modules-item blue ques-type ques-person-btn"
          >
            <div class="modules-item-icon icon-xinxi"></div>
            <span id="quesBtn" class="modules-item-text">{{
              $store.getters.getBtnText?.personalBtn
            }}</span>
          </div>
          <!-- 填报记录 -->
          <div
            v-if="$store.getters.getBtnText?.quesRecordBtnText"
            @click="handleJump2('ques-record')"
            class="modules-item blue ques-type ques-record-btn"
          >
            <div class="modules-item-icon icon-xinxi"></div>
            <span id="quesBtn" class="modules-item-text">{{
              $store.getters.getBtnText?.quesRecordBtnText
            }}</span>
          </div>
          <!-- 填报管理 -->
          <div
            v-if="showAdminBtn"
            @click="handleJump2('admin')"
            class="modules-item blue ques-type ques-admin-btn"
          >
            <div class="modules-item-icon icon-admin"></div>
            <span id="quesBtn" class="modules-item-text">{{
              $store.getters.getBtnText?.adminBtn
            }}</span>
          </div>
            <!-- 我的证书 -->
            <div
              v-if="certificatePreview || (certificateStatus && certificateStatus !== 1)"
              class="modules-item blue ques-type certificate-btn"
              @click="
                () => {
                  handleJump2('certificate')
                  handleBuryPointClick('我的证书')
                }
              "
            >
              <div class="modules-item-icon icon-paihang"></div>
              <span id="rankBtn" class="modules-item-text">{{
                $store.getters.getBtnText?.certificateBtnText
              }}</span>
            </div>
        </template>
        <template v-else>
          <template v-for="item in btnSort" :key="item">
            <!-- 试题学习 -->
            <div
              v-if="quesSetting?.isStudy === 2 && item === 0"
              to="/single/1"
              class="modules-item blue btn1"
              @click="
                () => {
                  handleJump2('study')
                  handleBuryPointClick('试题学习')
                }
              "
            >
              <div class="modules-item-icon icon-study"></div>

              <span id="studyBtn" class="modules-item-text">{{
                $store.getters.getBtnText?.studyBtn
              }}</span>
            </div>
            <!-- 模拟考试 -->
            <div
              @click="
                () => {
                  handleJump2('mock')
                  handleBuryPointClick('模拟考试')
                }
              "
              v-if="quesSetting?.isMock === 2 && item === 1"
              to="/list"
              class="modules-item blue btn2"
            >
              <div class="modules-item-icon icon-test"></div>
              <span id="mockBtn" class="modules-item-text">{{
                $store.getters.getBtnText?.mockBtn
              }}</span>
            </div>
            <!-- 正式考试 -->
            <Button
              @click="
                () => {
                  handleJump2('exam')
                  handleBuryPointClick('正式考试')
                }
              "
              v-if="quesSetting?.isExam === 2 && item === 2"
              style="padding: 0; border: none"
              class="modules-item blue special-color btn3"
            >
              <div class="exam-btn">
                <div class="modules-item-icon icon-exam"></div>
                <span id="examBtn" class="modules-item-text">{{
                  $store.getters.getBtnText?.examBtn
                }}</span>
              </div>
            </Button>
            <!-- 试题说明 -->
            <div
              v-if="quesSetting?.isIntroduction === 2 && item === 3"
              to="/single/1"
              class="modules-item blue btn4"
              @click="tipsPopup = true"
            >
              <div class="modules-item-icon icon-shuoming"></div>
              <span id="explainBtn" class="modules-item-text">{{
                $store.getters.getBtnText?.explainBtn
              }}</span>
            </div>
            <!-- 参赛排行 -->
            <div
              v-if="quesSetting?.isRank === 2 && item === 4"
              class="modules-item blue btn5"
              @click="
                () => {
                  handleJump2('competitionRank')
                  handleBuryPointClick('参赛排行')
                }
              "
            >
              <div class="modules-item-icon icon-paihang"></div>
              <span id="rankBtn" class="modules-item-text">{{
                $store.getters.getBtnText?.rankBtn
              }}</span>
            </div>
            <!-- 我的成绩 -->
            <div
              v-if="
                $store.getters.getOrgId !== '21' &&
                quesSetting?.isScore === 2 &&
                item === 5
              "
              class="modules-item blue btn6"
              @click="
                () => {
                  handleJump2('rank')
                  handleBuryPointClick('我的成绩')
                }
              "
            >
              <div class="modules-item-icon icon-chengji"></div>
              <span id="scoreBtn" class="modules-item-text">{{
                $store.getters.getBtnText?.scoreBtn
              }}</span>
            </div>
            <!-- 个人信息 -->
            <div
              v-if="quesSetting?.isInfo === 2 && item === 6"
              to="/single/1"
              class="modules-item blue btn7"
              @click="
                () => {
                  handleJump2('info')
                  handleBuryPointClick('个人信息')
                }
              "
            >
              <div class="modules-item-icon icon-xinxi"></div>
              <span id="infoBtn" class="modules-item-text">{{
                $store.getters.getBtnText?.infoBtn
              }}</span>
            </div>
            <!-- 答卷记录 -->
            <div
              v-if="quesSetting?.isRecord === 2 && item === 7"
              to="/single/1"
              class="modules-item blue btn8"
              @click="
                () => {
                  handleJump2('record')
                  handleBuryPointClick('答卷记录')
                }
              "
            >
              <div class="modules-item-icon icon-jilu"></div>
              <span id="recordBtn" class="modules-item-text">{{
                $store.getters.getBtnText?.recordBtn
              }}</span>
            </div>
            <!-- 我的证书 -->
           <div
              v-if="(certificatePreview || (certificateStatus && certificateStatus !== 1)) && item === 9"
              class="modules-item blue certificate-btn"
              @click="
                () => {
                  handleJump2('certificate')
                  handleBuryPointClick('我的证书')
                }
              "
            >
              <div class="modules-item-icon icon-paihang"></div>
              <span id="rankBtn" class="modules-item-text">{{
                $store.getters.getBtnText?.certificateBtnText
              }}</span>
            </div>
            <!-- 其他 -->
            <div
              v-if="quesSetting?.isOther === 2 && item === 8"
              to="/single/1"
              class="modules-item blue btn9"
              @click="
                () => {
                  handleJump2('other')
                  handleBuryPointClick('其他')
                }
              "
            >
              <div class="modules-item-icon icon-qita"></div>
              <span id="otherBtn" class="modules-item-text">{{
                $store.getters.getBtnText?.otherBtn
              }}</span>
            </div>
          </template>

          <div
            v-if="
              !quesSetting ||
              (quesSetting?.isStudy === 1 &&
                quesSetting?.isMock === 1 &&
                quesSetting?.isExam === 1)
            "
            class="modules-item blue"
          >
            <span class="modules-item-text">暂未添加模块</span>
          </div>
        </template>
      </div>
      <Password v-if="isPassword == 1" @onEmit="handlePasswordSubmit" />
      <PersonQues
        v-if="showPersonList"
        @close="showPersonList = false"
        @finishedPerson="handleFinishedPerson"
        :personList="personList"
      />
    </div>

    <!-- pk加载匹配窗 -->
    <PkLoading v-if="showPkLoading" />
  </div>
  <!-- 领取证书弹窗 -->
  <CertificateDialog v-if="showCertificate" :show="showCertificate" @close="showCertificate = false" />
  <BeforeToast
    v-if="showBeforeToast"
    @confirm="handleBeforeToastConfirm"
    @close="showBeforeToast = false"
  />
</template>

<script>
import axios from 'axios'
import { reactive, ref, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute, onBeforeRouteUpdate } from 'vue-router'
import {
  Loading,
  Dialog,
  Icon,
  ActionSheet,
  Overlay,
  NoticeBar,
  Button,
} from 'vant'
import { WebBridgeApi } from 'ijsbridge'
import { getPessonQuesList } from '@/api/index'
import PersonQues from './components/personQues'
import LeaderBoard from './components/leaderboard'
import TipsPopup from './components/tipsPopup'
import MoreBtn from './components/moreBtn'
import Password, { useShowPasswordEffect } from '@/components/password/Password'

import { useCommonGetSubmitCount } from '@/effects/submitEffect'
import { getUserSelectionInfo, getBindModuleInfo } from '@/api/person'
import { useAppGoBack } from '@/hooks/index.js'
import { getWhiteList } from '@/api/rank'
import { useStartBtnClick } from '@/hooks'
import {
  QUES_KEY_2023_4_12,
  JUNAN_ORG_ID,
  JINRILI_ORG_ID,
  SHANDONG_XIANRONG_ORG_ID,
  DOWNLOAD_URL,
  DOWNLOAD_URL_LY,
  DOWNLOAD_URL_SD_NEWS_IOS,
  DOWNLOAD_URL_SD_NEWS_ANDROID,
  QUES_KEY_2023_11_15,
} from '@/constants'
import { isAndroid } from 'vant/lib/utils'
import { getAdminAuth } from '@/api/admin'
import { getCertificateStatus } from '@/api/certificate'
import PkLoading from './components/pkLoading'
import BeforeToast from '@/components/beforeToast'
import CertificateDialog  from '@/components/certificateDialog/index.vue'
import { getQueryString, isChildrenChannel, isInApp as InApp } from '@/utils/tools'

export default {
  components: {
    Loading,
    TipsPopup,
    PersonQues,
    LeaderBoard,
    MoreBtn,
    ActionSheet,
    Password,
    Icon,
    Overlay,
    NoticeBar,
    Button,
    PkLoading,
    BeforeToast,
    CertificateDialog
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()

    const loading = ref(false)
    const questionActiveKey = getQueryString('questionActiveKey')

    const certificatePreview = getQueryString('certificatePreview')

    // 路由变化时候，报名问卷如果是隐藏首页，跳转到列表页
    watch(
      () => route.path,
      (newValue, oldValue) => {
        if (store.getters.getIsHideHome && store.getters?.getQuesInfo.type === 1) {
          router.push({
            path: '/list',
            query: route.query,
          })
        }
      }, {
        immediate: true
      }
    )

    // 跳转到国学小名士
    if (isChildrenChannel(questionActiveKey)) {
      loading.value = true
      const router = useRouter()
      const route = useRoute()

      router.push({
        path: '/little-celebrity',
        query: route.query,
      })
    }

    useTypeShowEffect()

    // 证书领取状态 1-没有证书 2-有未领取的证书 3-已领取证书
    const certificateStatus = ref(1)
    const showCertificate = ref(false)
    // 获取证书领取状态
    const fetchCertificateStatus = async () => {

      const res = await getCertificateStatus({
        questionActiveKey: route.query.questionActiveKey,
      }, {
        headers: {
          'CQ-MEMBER-TOKEN': store.getters.getToken,
        },
      })
      if (res.ok) {
        certificateStatus.value = res.data
      }
    }

    // 从app获取token会慢一点，所以需要watch
    watch(() => store.getters?.getToken, (newValue, oldValue) => {
      fetchCertificateStatus()
    })

    onMounted(() => {
      fetchCertificateStatus()
    })


    // 说明按钮
    const { showMoreBtn } = useMoreBtnEffect()

    const tipsPopup = ref(false)
    const showLeaderBoard = ref(false)

    // 获取答题次数
    const { isLimit, getLimitInfo, limtLoading } = useCommonGetSubmitCount()

    useWebLoginEffect(isLimit, getLimitInfo, loading)

    const { personList } = usePesonListEffect()

    // 是否展示pk匹配弹窗
    const showPkLoading = ref(false)

    // 是否显示填报前弹窗
    const showBeforeToast = ref(false)
    // 是否同意过填报前弹窗
    const isAgreeBeforeToast = ref(false)

    // 不同按钮点击相关逻辑
    const { handleJump2, quesSetting, showPersonList, handleFinishedPerson } =
      useModuleClickEffect(isLimit, personList, showLeaderBoard, showPkLoading, showBeforeToast, isAgreeBeforeToast, certificateStatus, showCertificate)

    // 填报前同意按钮点击
    const handleBeforeToastConfirm = () => {
      showBeforeToast.value = false

      isAgreeBeforeToast.value = true

      handleJump2(store.getters.getQuesInfo?.type === 1 ? 'list' : 'exam', {
        isAgreeBeforeToast: true,
      })
      // 归零，每次点击都需要弹窗
      isAgreeBeforeToast.value = false
    }

    // 按钮整体点击拦截处理
    const { clickCapture } = useClickEffect(isLimit, getLimitInfo, loading)

    // 答题密码相关
    const { isPassword, handlePasswordSubmit } = useShowPasswordEffect()


    const handleJump2Record = () => {
      router.push({
        path: '/person/record',
        query: route.query,
      })
    }

    const btnSort = ref([])
    btnSort.value =
      store.getters.getBtnText?.btnSort.length == 0
        ? [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
        : store.getters.getBtnText?.btnSort

    const moreBtnsShow = ref(false)
    moreBtnsShow.value =
      store.getters.getBtnText?.moreBtnsShow == '1' ? true : false

    watch(store.getters.getBtnText, (newValue, oldValue) => {
      btnSort.value =
        store.getters.getBtnText?.btnSort.length == 0
          ? [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
          : store.getters.getBtnText?.btnSort
      moreBtnsShow.value =
        store.getters.getBtnText?.moreBtnsShow == '1' ? true : false
    })

    // 埋点点击
    const handleBuryPointClick = (name) => {
      name &&
        useStartBtnClick({
          buttonName: name,
          quesTitle: store.getters.getQuesInfo?.title,
        })
    }

    // 显示填报管理按钮
    const showAdminBtn = computed(() => {
      const isPreview = getQueryString('isPreview')
      return (
        (store.getters.getHasAdminAuth || isPreview) &&
        store.getters.getBtnText?.adminBtn &&
        (store.getters.getOrgId == 29 ||
          store.getters.getOrgId == JUNAN_ORG_ID ||
          store.getters.getOrgId == SHANDONG_XIANRONG_ORG_ID ||
          store.getters.getOrgId == JINRILI_ORG_ID)
      )
    })

    const quesInfo = computed(() => store.getters.getQuesInfo)

    const showTitle = computed(() => {
      return quesInfo.value?.title.replaceAll('\n', '<br/>')
    })

    return {
      moreBtnsShow,
      showMoreBtn,
      tipsPopup,
      limtLoading,
      showTitle,
      quesInfo,
      quesSetting,
      personList,
      showPersonList,
      showPkLoading,
      showBeforeToast,
      handleJump2,
      clickCapture,
      certificatePreview,
      showCertificate,
      certificateStatus,
      isPassword,
      handlePasswordSubmit,
      showLeaderBoard,
      handleFinishedPerson,
      handleJump2Record,
      btnSort,
      loading,
      questionActiveKey,
      handleBuryPointClick,
      showAdminBtn,
      QUES_KEY_2023_4_12,
      handleBeforeToastConfirm
    }
  }
}

// 更多按钮显示逻辑
const useMoreBtnEffect = () => {
  const store = useStore()
  const showMoreBtn = computed(() => {
    // 开启登录 && （显示排行按钮 || 显示提示按钮 || 有个人选项信息）
    return JSON.parse(store.getters.getQuesInfo?.style)?.cover?.moreBtnsShow
  })
  return {
    showMoreBtn,
  }
}

// 处理不同类型（问卷、闯关）跳转
const useTypeShowEffect = () => {
  const store = useStore()
  const router = useRouter()
  const route = useRoute()
  const quesSetting = store.getters.getQuesSetting
  const quesInfo = store.getters.getQuesInfo

  if (quesInfo?.type === 11) {
    router.replace({
      path: '/custom/sdws/home',
      query: {
        ...route.query,
      },
    })
  }

  // 闯关，type==11 是pk
  if (quesSetting?.isLevel === 2 && quesInfo?.type !== 11) {
    router.replace({
      path: '/competition/home',
      query: {
        ...route.query,
      },
    })
  }
}

// 捕获点击事件 做一些限制，比如登录处理、暂停收集处理
const useClickEffect = (isLimit, getLimitInfo, loading) => {
  const store = useStore()
  const router = useRouter()
  const route = useRoute()
  const quesInfo = store?.getters?.getQuesInfo
  const isInApp = InApp()
  const isPreview = getQueryString('isPreview')
    ? Number(getQueryString('isPreview'))
    : 0
  let flag = false
  // let message = '登录客户端后方可开始答卷哦，感谢您的配合~'
  // 开启登录弹窗
  if (quesInfo?.isLogin === 1 && !store.getters.getToken) {
    flag = true
    // app里未登录 直接调用登录接口
    if (isInApp) {
      flag = true
      WebBridgeApi.authorize().then(({ err, result }) => {
        if (err === 'cancel') {
          // message = '登录客户端后方可开始答卷哦，感谢您的配合~'
          flag = true
          useAppGoBack()
        }
        const token = result.token || result.user.token
        store.commit('setToken', {
          token,
        })
        store.commit('setUser', {
          user: {
            avatar: result.user.avatar,
            nickname: result.user.nickname,
            id: result.user.id,
          },
        })
        if (store.getters.getQuesInfo?.type === 1) {
          store.dispatch('getAdminTree')
        }
        useFetchPersonInfo(store, loading)
        fetchWhiteList(store)
        getLimitInfo(isLimit)
        flag = false
        // localStorage.setItem('token', token)
      })
    }
  }
  const clickCapture = (e, type) => {
    // 预览不做处理
    if (isPreview === 1) {
      return
    }

    // 后台设置样式时候，屏蔽点击事件
    if (getQueryString('isSetting')) {
      e.stopPropagation()
      return
    }

    if ((quesInfo?.status === 3 || quesInfo?.status === 4) && !type) {
      Dialog({ message: '此系统已暂停收集，请等待再次开启后使用！' })
      e.stopPropagation()
      return
    }
    if (quesInfo?.status === 5 && !type) {
      Dialog({ message: '活动未开始' })
      e.stopPropagation()
      return
    }

    const orgid = getQueryString('orgid')
    // 登录类型设置为2的时候， 网页里即使已经登录 也需要跳转下载页
    if (quesInfo?.webLogin === 2 && !isInApp) {
      let url = `${DOWNLOAD_URL}?orgid=${orgid}`

      if (orgid === '409') {
        url = DOWNLOAD_URL_LY
      } else if (orgid === '21') {
        if (isAndroid()) {
          url = DOWNLOAD_URL_SD_NEWS_ANDROID
        } else {
          url = DOWNLOAD_URL_SD_NEWS_IOS
        }
      } else {
        url = `${DOWNLOAD_URL}?orgid=${orgid}`
      }

      window.open(url)
      e.stopPropagation()
    }
    if (quesInfo?.isLogin === 1 && !isInApp) {
      if (!store.getters.getToken) {
        e.stopPropagation()
        // 到自定义登录
        if (quesInfo?.webLogin === 3) {
          router.push({
            path: '/login',
            query: route.query,
          })
        } else {
          handleWebLogin(store.getters.getQuesInfo)
        }
      } else {
        return
      }
    }
    if (!flag) {
      return
    }
    if (isInApp) {
      WebBridgeApi.authorize().then(({ err, result }) => {
        if (err === 'cancel') {
          // message = '登录客户端后方可开始答卷哦，感谢您的配合~'
          flag = true
          WebBridgeApi.router({ route: 'back' })
        }
        const token = result.user.token

        store.commit('setToken', {
          token,
        })
        useFetchPersonInfo(store, loading)
        getLimitInfo(isLimit)

        flag = false
      })
    }
    e.stopPropagation()
  }

  return {
    clickCapture,
  }
}

// 不同模块路由跳转
const useModuleClickEffect = (
  isLimit,
  personList,
  showLeaderBoard,
  showPkLoading,
  showBeforeToast,
  isAgreeBeforeToast,
  certificateStatus,
  showCertificate
) => {
  const store = useStore()
  const router = useRouter()
  const route = useRoute()
  const showPersonList = ref(false)

  if (route.query.showPersonList) {
    showPersonList.value = true
  }

  let jumpUrl = reactive({})
  const isPreview = getQueryString('isPreview')
    ? Number(getQueryString('isPreview'))
    : 0
  const isSetting = getQueryString('isSetting')
  const quesSetting = store.getters.getQuesSetting
  // 没有添加任何模块
  if (
    quesSetting?.isStudy === 1 &&
    quesSetting?.isMock === 1 &&
    quesSetting?.isExam === 1 &&
    quesSetting?.isLevel === 1
  ) {
    Dialog({ message: '尚未添加任何模块，请先添加模块' })
  }

  const handleJump2 = (type, option) => {
    if (
      store.getters.getQuesInfo?.status === 7 &&
      (type === 'exam' || type === 'list')
    ) {
      Dialog({ message: '已到作答最大参与数量，感谢参与！' })
      return
    }

    if (
      store.getters.getQuesInfo?.status === 6 &&
      (type === 'exam' || type === 'study' || type == 'mock' || type === 'list')
    ) {
      Dialog({ message: '活动已结束' })
      return
    }

    const param = {
      path: '/',
      query: {
        ...route.query,
        type: type,
      },
      params: {}
    }

    // 没有排行配置 直接弹窗
    if (type === 'competitionRank' && !store.getters.getRankConfig) {
      showLeaderBoard.value = true
      return
    }

    if (type === 'exam' && store.getters.getIsBlock) {
      Dialog({ message: '抱歉，您还不具备参与资格！' })
      return
    }
    // 正常时候
    if (
      (type === 'exam' ||
        (store.getters.getQuesInfo?.type === 1 && type === 'list')) &&
      !isLimit.value &&
      isPreview !== 1
    ) {
      Dialog({ message: '已超过次数限制' })
      return
    }
    if (type === 'list') {
      param.path = '/list'
    } else if (type === 'study') {
      param.path = '/single/1'
      param.query.isStudy = true
    } else if (type === 'explain') {
      param.path = '/explain'
    } else if (type === 'competitionRank') {
      param.path = '/person/competitionrank'
    } else if (type === 'rank') {
      param.path = '/person/rank'
    } else if (type === 'score') {
      param.path = '/score'
    } else if (type === 'info') {
      param.path = '/person/info'
      param.query.typeId = store.getters.getModuleInfo?.typeId
    } else if (type === 'ques-record') {
      param.path = '/person/record'
    } else if (type === 'record') {
      param.path = '/person/record'
    } else if (type === 'admin') {
      param.path = '/admin'
    } else if (type === 'certificate') {
      param.path = '/person/certificate'
    } else {
      if (quesSetting && quesSetting.showType === 1) {
        param.path = '/list'
      } else if (quesSetting.showType === 2) {
        param.path = '/single/1'
      } else {
        return null
      }
    }
    const quesInfo = store.getters.getQuesInfo
    const userSelectionInfo = store.getters.getUserSelection
    // 问卷绑定了个人信息 && 用户没有回答过 需要跳到个人信息页面去
    if (
      isPreview !== 1 &&
      !userSelectionInfo &&
      quesInfo.isLogin === 1 &&
      (type === 'list' || 'single') &&
      quesInfo.moduleId
    ) {
      // pk填写完个人信息到首页
      if (store.getters?.getQuesSetting?.isLevel === 3) {
        param.query.oldPath = '/'
      } else {
        param.query.oldPath = param.path
      }
      param.path = '/person/info'
      param.query.first = 1

      router.push(param)

      return
    }

    if (type === 'other') {
      if (store.getters.getBtnText?.otherUrl.startsWith('http')) {
        window.location.href = store.getters.getBtnText?.otherUrl

        return
      } else {
        const quesInfo = store.getters.getQuesInfo
        router.push({
          path: store.getters.getBtnText?.otherUrl,
          query: { questionActiveKey: quesInfo.setting.questionActiveKey },
        })
      }

      return
    }

    // 我的证书需要判断一下领取状态
    // 1-没有证书 2-有未领取的证书 3-已领取证书
    if (type === 'certificate') {
      if (certificateStatus.value === 1) {

        return
      } else if (certificateStatus.value === 2) {

        showCertificate.value = true

        return
      }
    }

    // 是否是填报前弹窗跳转，需要加一个首页标识
    if (option?.isAgreeBeforeToast) {
      param.query.isAgreeBeforeToast = true
    }

    // 开启填报前弹窗
    if (store.getters?.isShowBefore && !isAgreeBeforeToast.value && (type === 'exam' || type === 'list') ) {
      showBeforeToast.value = true
      return
    }

    // 有个人题型的答题之前需要弹一下框
    if (personList.value.length > 0 && type === 'exam') {
      showPersonList.value = true
      jumpUrl = param

      return
    }

    // pk需要去pk页面
    if (quesSetting?.isLevel === 3 && type === 'exam') {
      showPkLoading.value = true
      return
    }

    // 记录答题开始时间
    store.commit('setStartTime', {
      time: new Date(),
    })
    router.push(param)
  }

  // 答完个人题
  const handleFinishedPerson = () => {
    // 记录答题开始时间
    store.commit('setStartTime', {
      time: new Date(),
    })
    router.push(jumpUrl)
  }

  return {
    quesSetting,
    showPersonList,
    handleJump2,
    handleFinishedPerson,
  }
}

// 获取个人题型
const usePesonListEffect = () => {
  const personList = ref([])
  const store = useStore()
  let type = 1
  if (store.getters.getQuesInfo?.type !== 1) {
    type = 2
  }

  // 有缓存给赋值
  const setHistroyData = () => {
    const historyData = JSON.parse(
      JSON.stringify(store.getters.getInputCacheListObj)
    )
    // 遍历缓存数据 如果有答题记录 则赋值
    personList.value.forEach((item) => {
      const history = historyData[item.questionKey]
      if (history) {
        item.value = history[history.length - 1]
      }
    })
  }

  const getData = async () => {
    const res = await getPessonQuesList({
      questionActiveKey: getQueryString('questionActiveKey'),
      type,
    })

    personList.value = res?.data
    setHistroyData()
  }

  // 报名的时候 个人题型不需要在外边展示
  if (store.getters.getQuesInfo?.type !== 1) {
    getData()
  }

  return {
    personList,
  }
}

// web登录
const handleWebLogin = (quesInfo) => {
  const isFromIframe = getQueryString('isFromIframe')
  // 如果是iframe进来的，postMessage出去 教给外层登陆
  if (isFromIframe) {
    // postMessage出去token
    parent.postMessage(
      {
        needLogin: true
      },
      '*'
    )
    return
  }

  const orgid = getQueryString('orgid')
  const backurl = encodeURIComponent(window.location.href)
  let url = `https://app-auth.iqilu.com?orgId=${orgid}&_orgid_=${orgid}&backurl=${backurl}`
  if (orgid === '29') {
    url = `https://app-auth.iqilu.com?isStyleTmp=1&orgId=${orgid}&_orgid_=${orgid}&backurl=${backurl}`
  }
  if (quesInfo?.webLogin === 2) {
    if (orgid === '21') {
      if (isAndroid()) {
        url = DOWNLOAD_URL_SD_NEWS_ANDROID
      } else {
        url = DOWNLOAD_URL_SD_NEWS_IOS
      }
    } else if (orgid === '409') {
      url = DOWNLOAD_URL_LY
    } else {
      url = `${DOWNLOAD_URL}?orgid=${orgid}`
    }
  }
  window.location.href = url
}

// 处理网页登录跳回来逻辑
const useWebLoginEffect = async (isLimit, getLimitInfo, loading) => {
  const store = useStore()
  const token = window.location.search.substr(1).split('=')[1]

  if (token && !store.getters.getToken) {
    const { data } = await axios.get(
      `https://app-auth.iqilu.com/member/login_state?__token__=${token}`
    )
    if (data?.code === 1) {
      store.commit('setUser', {
        user: {
          avatar: data?.data?.avatar,
          nickname: data?.data?.nickname,
          id: data?.data?.id,
        },
      })
      if (data?.data?.token) {
        store.commit('setToken', {
          token: data?.data?.token,
        })
        localStorage.setItem('token', data?.data?.token)
        let url = decodeURIComponent(window.location.href)
        if (url.indexOf('amp;') !== -1) {
          url = url.replace(/amp;/g, '')
        }
        window.location.replace(url)
        getLimitInfo(isLimit)
      }
    }
  }
  if (store.getters.getToken) {
    useFetchPersonInfo(store, loading)
    fetchWhiteList(store)
  }
}

// 获取白名单配置
const fetchWhiteList = async (store) => {
  const res = await getWhiteList({
    questionActiveKey: getQueryString('questionActiveKey'),
    token: store.getters.getToken,
  })

  if (res.ok) {
    store.commit('setIsBlock', !res.data)
  }
}

// 获取问卷绑定个人信息
const useFetchPersonInfo = async (store, loading) => {
  const fetchData = async () => {
    loading.value = true
    const res = await getUserSelectionInfo({
      questionActiveKey: getQueryString('questionActiveKey'),
      token: store.getters.getToken,
    })

    if (res.ok) {
      store.commit('setUserSelection', {
        data: res.data,
      })
      // 查绑定的模板信息
      await useFetchModuleInfo(store, loading)
    }
  }

  await fetchData()
}

// 获取模板信息
const useFetchModuleInfo = async (store, loading) => {
  if (!store.getters.getQuesInfo.moduleId) {
    loading.value = false
    return
  }
  const fetchData = async () => {
    const res = await getBindModuleInfo({
      moduleId: store.getters.getQuesInfo.moduleId,
      orgId: store.getters.getOrgId,
    })
    if (res.ok) {
      store.commit('setModuleInfo', {
        data: res.data[0],
      })
    }
    loading.value = false
  }

  await fetchData()
}
</script>

<style lang="scss">
.cover {
  margin: 0 auto;
  width: 750px;
  // width: 100%;
  min-height: 100vh;
  // min-height: calc(100vh - 0.9rem);
  // min-height: 1624px;

  .record-btn {
    position: fixed;
    top: 20px;
    right: 10px;
    padding: 10px 20px;
    font-size: 34px;
    background-color: rgba($color: #000000, $alpha: 0.1);
    font-weight: 400;
    color: #000;
    border-radius: 20px;
  }

  .title {
    margin: 0 40px;
    padding-top: 88px;
    margin-bottom: 88px;
    font-weight: bold;
    // line-height: 48px;
    line-height: 1.2;
    text-align: center;
    font-size: 60px;
    color: #333333;
    line-height: 1.2;
  }

  .person-btn {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 20px;
    right: 23px;
    width: 60px;
    height: 45px;
    border-radius: 10px;
    //background-color: #f0f0f0;
    // height: 60px;
    // width: 182px;
    // height: 56px;
    // background: #dbeeff;
    // border-radius: 28px 0px 0px 28px;
    // font-size: 28px;
    // color: #3795ff;
    background: no-repeat center/100% url('../../assets/img/gengduo.svg');
  }

  .topArrow {
    position: relative;
    top: 60px;
    left: 683px;
    width: 0;
    height: 0;
    position: relative;
    border: 15px solid;
    border-color: transparent transparent #fff transparent;
  }

  .more-btn-list {
    position: absolute;
    top: 86px;
    right: 20px;
    border-radius: 10px;
    // height: 326px;
    background-color: #fff;
    box-shadow: 0px 0px 8px 0px rgba(86, 86, 86, 0.2);
    padding: 25px 25px 27px;

    .item {
      width: 190px;
      padding: 20px 0;
      text-align: left;
      font-size: 32px;
      font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
        Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', miui,
        'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
      border-bottom: 3px solid #d0d0d5;
      border-color: rgba(208, 208, 213, 0.2);
    }

    .item:last-child {
      border-color: rgba(208, 208, 213, 0);
    }

    .more-btn-item {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: 104px;
      font-size: 34px;
      font-weight: 400;
      color: #555555;
      border-bottom: 1px solid rgba($color: #565656, $alpha: 0.1);

      &:last-child {
        border: none;
      }

      span {
        margin-left: 26px;
      }
    }
  }

  .tips-img {
    display: block;
    position: relative;
    top: -28px;
    margin: 0 auto;
    width: 351px;
    height: 80px;
  }

  .tips {
    margin: 0 auto;
    box-sizing: border-box;
    padding: 26px 60px;
    width: 700px;
    height: 385px;
    overflow-y: scroll;
    background: #f0f0f0;
    border-radius: 10px;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 25px 0;
    }

    p {
      margin: 20px 0;
      line-height: 1.5;
      font-size: 32px;

      &:first-child {
        margin: 0;
      }
    }
  }

  .ques-tips {
    margin-top: 88px;
    height: 666px;
  }

  .modules {
    margin-top: 20px;
    box-sizing: border-box;
    // display: flex;
    // justify-content: space-between;
    //margin-top: 44px;
    // width: 700px;
    // padding: 0 25px;

    .blue {
      background: linear-gradient(-90deg, #1782f0 0%, #22a8f4 100%);
    }

    .green {
      background: linear-gradient(-90deg, #3ed6c0 0%, #3ed6c0 100%);
    }

    .purple {
      background: linear-gradient(-8deg, #ec6d51, #ffb192);
    }

    &-item-col {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      margin-bottom: 30px;
      width: 224px;
      height: 85px;
      border-radius: 10px;

      &-icon {
        width: 60px;
        height: 60px;
      }

      &-text {
        font-size: 28px;
        font-weight: bold;
        color: #ffffff;
      }
    }

    .btn-size {
      width: 358px;
      height: 109px;
      display: flex;
      justify-content: center;

      .modules-item-icon {
        display: none;
      }

      .modules-item-text {
        margin-left: 0;
      }
    }

    &-item {
      display: flex;
      align-items: center;
      margin: 0 auto;
      margin-bottom: 30px;
      width: 700px;
      height: 150px;
      border-radius: 10px;

      &-icon {
        margin-left: 84px;
        width: 172px;
        height: 153px;
      }

      .icon-study {
        background: no-repeat left/100%
          url('../../assets/img/study-icon-big.png');
      }

      .icon-test {
        background: no-repeat left/100%
          url('../../assets/img/test-exam-icon-big.png');
      }

      .icon-exam {
        background: no-repeat left/100%
          url('../../assets/img/exam-icon-big.png');
      }

      .icon-shuoming {
        background: no-repeat left/100%
          url('../../assets/img/shuoming-icon-big.png');
      }

      .icon-paihang {
        background: no-repeat left/100%
          url('../../assets/img/paihang-icon-big.png');
      }

      .icon-chengji {
        background: no-repeat left/100%
          url('../../assets/img/chengji-icon-big.png');
      }

      .icon-xinxi {
        background: no-repeat left/100%
          url('../../assets/img/xinxi-icon-big.png');
      }

      .icon-admin {
        background: no-repeat left/100% url('../../assets/img/admin-icon.png');
      }

      .icon-jilu {
        background: no-repeat left/100%
          url('../../assets/img/jilu-icon-big.png');
      }

      .icon-qita {
        background: no-repeat left/100%
          url('../../assets/img/qita-icon-big.png');
      }

      &-text {
        margin-left: 59px;
        font-size: 34px;
        color: #ffffff;
      }

      .exam-btn {
        display: flex;
        align-items: center;
      }
    }
  }
}


.modules-item-icon {
  display: none !important;
}

.modules-item {
  display: flex;
  align-items: center;
  justify-content:center;
  .modules-item-text {
    margin: 0;
    width: 100%;
    display: inline-block;
    text-align: center !important;
  }

}

.diy-btn-2023412 {
  position: relative;
  top: -80px;
  justify-content: center;
  width: 360px !important;
  height: 109px !important;

  .modules-item-icon {
    display: none;
  }

  #quesBtn {
    margin: 0;
  }
}

.diy-btn-20240117 {
  margin-top: 110px !important;
  width: 650px !important;
  height: 120px !important;
}

button {
  border: none;
}

// @media (min-width: 1200px) {
//   .cover {
//     /* prettier-ignore */
//     width: 1200px;
//   }
// }
</style>
